export default function SelectorBase({ base, setBase }) {
  return (
    <div className="space-y-2">
      <label className="font-semibold">🧃 Preparación</label>

      <select
        value={base}
        onChange={(e) => setBase(e.target.value)}
        className="w-full bg-[#1a1a1a] p-3 rounded"
      >
        <option value="">Selecciona Agua o Leche</option>
        <option value="Agua">Agua</option>
        <option value="Leche">Leche</option>
      </select>

      {!base && (
        <p className="text-red-400 text-sm">
          Debes elegir Agua o Leche
        </p>
      )}
    </div>
  );
}
